import { CountryCode } from '@/types';

// Comprehensive city data by country for Lead Lists
export const citiesByCountry: Record<CountryCode, string[]> = {
  BA: [
    // Federation of Bosnia and Herzegovina + Republika Srpska + Brčko District
    'Sarajevo', 'Banja Luka', 'Tuzla', 'Zenica', 'Mostar',
    'Bijeljina', 'Brčko', 'Bihać', 'Prijedor', 'Doboj',
    'Cazin', 'Trebinje', 'Livno', 'Gradačac', 'Gradiška',
    'Visoko', 'Goražde', 'Konjic', 'Bugojno', 'Travnik',
    'Lukavac', 'Sanski Most', 'Vogošća', 'Kakanj', 'Zavidovići',
    'Velika Kladuša', 'Ilijaš', 'Zvornik', 'Hadžići', 'Ilidža',
    'Široki Brijeg', 'Čapljina', 'Stolac', 'Jablanica', 'Prozor-Rama',
    'Tomislavgrad', 'Posušje', 'Grude', 'Ljubuški', 'Neum',
    'Srebrenica', 'Bratunac', 'Vlasenica', 'Milići', 'Sokolac',
    'Pale', 'Istočno Sarajevo', 'Foča', 'Višegrad', 'Rogatica',
    'Rudo', 'Čajniče', 'Nevesinje', 'Gacko', 'Bileća',
    'Berkovići', 'Ljubinje', 'Ravno', 'Kalinovik', 'Trnovo',
    'Ustikolina', 'Olovo', 'Kladanj', 'Srebrenik', 'Gračanica',
    'Živinice', 'Kalesija', 'Sapna', 'Teočak', 'Čelić',
    'Lopare', 'Ugljevik', 'Šekovići', 'Osmaci', 'Han Pijesak',
    'Novo Sarajevo', 'Stari Grad Sarajevo', 'Centar Sarajevo', 'Novi Grad Sarajevo',
    'Laktaši', 'Čelinac', 'Kotor Varoš', 'Kneževo', 'Mrkonjić Grad',
    'Jajce', 'Donji Vakuf', 'Gornji Vakuf-Uskoplje', 'Novi Travnik', 'Vitez',
    'Busovača', 'Kiseljak', 'Fojnica', 'Kreševo', 'Vareš',
    'Breza', 'Maglaj', 'Tešanj', 'Usora', 'Doboj Jug',
    'Žepče', 'Petrovo', 'Modriča', 'Vukosavlje', 'Šamac',
    'Orašje', 'Domaljevac-Šamac', 'Odžak', 'Derventa', 'Prnjavor',
    'Srbac', 'Kozarska Dubica', 'Novi Grad', 'Krupa na Uni', 'Oštra Luka',
    'Ribnik', 'Glamoč', 'Drvar', 'Bosansko Grahovo', 'Kupres',
    'Ključ', 'Petrovac', 'Istočni Drvar', 'Jezero',
  ],
  HR: [
    // All Croatian cities and major municipalities
    'Zagreb', 'Split', 'Rijeka', 'Osijek', 'Zadar',
    'Pula', 'Slavonski Brod', 'Karlovac', 'Varaždin', 'Šibenik',
    'Sisak', 'Dubrovnik', 'Bjelovar', 'Vinkovci', 'Velika Gorica',
    'Vukovar', 'Koprivnica', 'Požega', 'Čakovec', 'Đakovo',
    'Samobor', 'Virovitica', 'Gospić', 'Makarska', 'Solin',
    'Sesvete', 'Kutina', 'Metković', 'Rovinj', 'Trogir',
    'Opatija', 'Crikvenica', 'Biograd na Moru', 'Mali Lošinj', 'Hvar',
    'Korčula', 'Ploče', 'Imotski', 'Sinj', 'Knin',
    'Kaštela', 'Petrinja', 'Križevci', 'Zapresic', 'Dugo Selo',
    'Ivanec', 'Ludbreg', 'Novi Marof', 'Lepoglava', 'Varaždinske Toplice',
    'Đurđevac', 'Pitomača', 'Daruvar', 'Garešnica', 'Grubišno Polje',
    'Čazma', 'Pakrac', 'Lipik', 'Pleternica', 'Kutjevo',
    'Slavonski Šamac', 'Nova Gradiška', 'Okučani', 'Novska', 'Glina',
    'Dvor', 'Topusko', 'Hrvatska Kostajnica', 'Sunja', 'Popovača',
    'Ivanić-Grad', 'Kloštar Ivanić', 'Vrbovec', 'Sveti Ivan Zelina',
    'Jastrebarsko', 'Ozalj', 'Duga Resa', 'Slunj', 'Ogulin',
    'Otočac', 'Senj', 'Novalja', 'Rab', 'Cres',
    'Krk', 'Bakar', 'Kastav', 'Kraljevica', 'Delnice',
    'Čabar', 'Vrbovsko', 'Buzet', 'Pazin', 'Labin',
    'Umag', 'Poreč', 'Novigrad', 'Vrsar', 'Bale',
    'Vodnjan', 'Medulin', 'Fažana', 'Barban', 'Svetvinčenat',
    'Benkovac', 'Obrovac', 'Pag', 'Nin', 'Starigrad',
    'Murter', 'Vodice', 'Primošten', 'Drniš', 'Trilj',
    'Vrgorac', 'Omiš', 'Supetar', 'Bol', 'Jelsa',
    'Stari Grad', 'Vis', 'Komiža', 'Lastovo', 'Blato',
    'Vela Luka', 'Orebić', 'Ston', 'Opuzen', 'Čilipi',
    'Cavtat', 'Županja', 'Ilok', 'Otok', 'Ivankovo',
    'Borovo', 'Negoslavci', 'Slatina', 'Orahovica', 'Našice',
    'Donji Miholjac', 'Belišće', 'Valpovo', 'Đurđenovac',
  ],
  RS: [
    // All Serbian cities and major municipalities
    'Belgrade', 'Novi Sad', 'Niš', 'Kragujevac', 'Subotica',
    'Zrenjanin', 'Pančevo', 'Čačak', 'Kruševac', 'Kraljevo',
    'Novi Pazar', 'Smederevo', 'Leskovac', 'Užice', 'Vranje',
    'Valjevo', 'Šabac', 'Sombor', 'Požarevac', 'Pirot',
    'Zaječar', 'Kikinda', 'Sremska Mitrovica', 'Jagodina', 'Vršac',
    'Bor', 'Prokuplje', 'Loznica', 'Paraćin', 'Gornji Milanovac',
    'Inđija', 'Stara Pazova', 'Bečej', 'Ruma', 'Apatin',
    'Temerin', 'Bačka Palanka', 'Kula', 'Odžaci', 'Senta',
    'Aranđelovac', 'Lazarevac', 'Obrenovac', 'Mladenovac', 'Sopot',
    'Grocka', 'Barajevo', 'Surčin', 'Zemun', 'Palilula',
    'Voždovac', 'Zvezdara', 'Čukarica', 'Rakovica', 'Savski Venac',
    'Stari Grad', 'Vračar', 'Novi Beograd', 'Batajnica',
    'Smederevska Palanka', 'Velika Plana', 'Svilajnac', 'Despotovac',
    'Ćuprija', 'Rekovac', 'Batočina', 'Knić', 'Topola',
    'Rača', 'Lapovo', 'Trstenik', 'Vrnjačka Banja', 'Aleksandrovac',
    'Brus', 'Blace', 'Žitorađa', 'Merošina', 'Doljevac',
    'Gadžin Han', 'Aleksinac', 'Ražanj', 'Svrljig', 'Sokobanja',
    'Knjaževac', 'Boljevac', 'Negotin', 'Kladovo', 'Majdanpek',
    'Žagubica', 'Kučevo', 'Petrovac na Mlavi', 'Malo Crniće',
    'Žabari', 'Golubac', 'Veliko Gradište', 'Kostolac',
    'Lučani', 'Ivanjica', 'Arilje', 'Bajina Bašta', 'Kosjerić',
    'Priboj', 'Prijepolje', 'Nova Varoš', 'Sjenica', 'Tutin',
    'Raška', 'Kopaonik', 'Kuršumlija', 'Lebane', 'Medveđa',
    'Vlasotince', 'Crna Trava', 'Vladičin Han', 'Surdulica', 'Bosilegrad',
    'Bujanovac', 'Preševo', 'Trgovište',
    'Kanjiža', 'Ada', 'Čoka', 'Novi Kneževac', 'Mali Iđoš',
    'Bačka Topola', 'Srbobran', 'Vrbas', 'Bečej', 'Žabalj',
    'Titel', 'Kovačica', 'Opovo', 'Alibunar', 'Plandište',
    'Bela Crkva', 'Kovin', 'Nova Crnja', 'Žitište', 'Sečanj',
    'Irig', 'Šid', 'Pećinci', 'Vladimirci', 'Koceljeva',
    'Bogatić', 'Mali Zvornik', 'Ljubovija', 'Osečina', 'Mionica',
    'Ljig', 'Lajkovac',
  ],
  SI: [
    // All Slovenian cities and major towns
    'Ljubljana', 'Maribor', 'Celje', 'Kranj', 'Velenje',
    'Koper', 'Novo Mesto', 'Ptuj', 'Trbovlje', 'Kamnik',
    'Jesenice', 'Nova Gorica', 'Domžale', 'Škofja Loka', 'Murska Sobota',
    'Izola', 'Piran', 'Postojna', 'Slovenj Gradec', 'Ravne na Koroškem',
    'Brežice', 'Krško', 'Lendava', 'Ajdovščina', 'Bled',
    'Bohinj', 'Portorož', 'Sežana', 'Ilirska Bistrica', 'Tolmin',
    'Radovljica', 'Tržič', 'Žalec', 'Laško', 'Rogaška Slatina',
    'Šmarje pri Jelšah', 'Šentjur', 'Slovenske Konjice', 'Zreče',
    'Slovenska Bistrica', 'Lenart', 'Gornja Radgona', 'Ljutomer',
    'Ormož', 'Kidričevo', 'Ruše', 'Dravograd', 'Mežica',
    'Črna na Koroškem', 'Prevalje', 'Muta', 'Radlje ob Dravi',
    'Hrastnik', 'Zagorje ob Savi', 'Litija', 'Šmartno pri Litiji',
    'Trebnje', 'Mokronog', 'Sevnica', 'Metlika', 'Črnomelj',
    'Ribnica', 'Kočevje', 'Logatec', 'Vrhnika', 'Grosuplje',
    'Ivančna Gorica', 'Mengeš', 'Trzin', 'Medvode', 'Vodice',
    'Bovec', 'Kobarid', 'Most na Soči', 'Idrija', 'Cerkno',
    'Vipava', 'Komen', 'Divača', 'Pivka', 'Cerknica',
    'Škocjan', 'Šempeter-Vrtojba', 'Miren-Kostanjevica',
    'Šenčur', 'Naklo', 'Preddvor', 'Kokrica', 'Železniki',
    'Gorenja Vas', 'Polhov Gradec', 'Dobrova', 'Brezovica',
    'Ig', 'Škofljica', 'Lavrica',
  ],
  ME: [
    // All Montenegrin municipalities and towns
    'Podgorica', 'Nikšić', 'Herceg Novi', 'Pljevlja', 'Bijelo Polje',
    'Cetinje', 'Bar', 'Budva', 'Ulcinj', 'Kotor',
    'Tivat', 'Berane', 'Rožaje', 'Danilovgrad', 'Mojkovac',
    'Kolašin', 'Žabljak', 'Plav', 'Andrijevica', 'Šavnik',
    'Petnjica', 'Gusinje', 'Tuzi', 'Zeta', 'Golubovci',
    'Sutomore', 'Petrovac', 'Sveti Stefan', 'Bečići', 'Rafailovići',
    'Igalo', 'Bijela', 'Baošići', 'Risan', 'Perast',
    'Dobrota', 'Prčanj', 'Stoliv', 'Lepetane', 'Kamenari',
    'Virpazar', 'Rijeka Crnojevića', 'Spuž', 'Bioče',
    'Šćepan Polje', 'Durmitor', 'Zabljak',
  ],
  MK: [
    // All North Macedonian cities and major towns
    'Skopje', 'Bitola', 'Kumanovo', 'Prilep', 'Tetovo',
    'Veles', 'Ohrid', 'Gostivar', 'Štip', 'Strumica',
    'Kavadarci', 'Kočani', 'Kičevo', 'Struga', 'Radoviš',
    'Gevgelija', 'Debar', 'Sveti Nikole', 'Negotino', 'Delčevo',
    'Vinica', 'Resen', 'Probištip', 'Berovo', 'Kratovo',
    'Kriva Palanka', 'Makedonski Brod', 'Demir Hisar', 'Demir Kapija',
    'Bogdanci', 'Valandovo', 'Dojran', 'Pehčevo', 'Makedonska Kamenica',
    'Kruševo', 'Centar Župa', 'Mavrovo', 'Rostušа', 'Tearce',
    'Želino', 'Jegunovce', 'Brvenica', 'Bogovinje', 'Vrapčište',
    'Lipkovo', 'Aračinovo', 'Ilinden', 'Petrovec', 'Sopište',
    'Studeničani', 'Čučer-Sandevo', 'Zelenikovo', 'Saraj',
    'Gazi Baba', 'Kisela Voda', 'Aerodrom', 'Centar', 'Čair',
    'Butel', 'Šuto Orizari', 'Gjorče Petrov', 'Karpoš',
    'Novo Selo', 'Vasilevo', 'Bosilovo', 'Konče', 'Zrnovci',
    'Čelepeševo', 'Dolneni', 'Mogila', 'Novaci', 'Gradsko',
    'Rosoman', 'Lozovo', 'Češinovo-Obleševo',
  ],
  OTHER: [
    'Other City',
  ],
};

// Country display names for the scraper UI
export const countryNames: Record<CountryCode, string> = {
  BA: 'Bosnia & Herzegovina',
  HR: 'Croatia',
  RS: 'Serbia',
  SI: 'Slovenia',
  ME: 'Montenegro',
  MK: 'North Macedonia',
  OTHER: 'Other',
};

// Default categories for lead lists
export const defaultCategories = [
  'Restaurants', 'Hotels', 'Retail', 'Fitness', 'Cafes',
  'Healthcare', 'Beauty & Wellness', 'Automotive', 'Real Estate',
  'Education', 'Professional Services', 'Manufacturing', 'Technology',
  'Construction', 'Entertainment', 'Food & Beverage', 'Tourism',
  'Agriculture', 'Finance', 'Legal Services',
];

// Get cities for a specific country
export const getCitiesForCountry = (countryCode: CountryCode): string[] => {
  return citiesByCountry[countryCode] || citiesByCountry.OTHER;
};

// Search cities across all countries or specific country
export const searchCities = (query: string, countryCode?: CountryCode): string[] => {
  const searchLower = query.toLowerCase();
  
  if (countryCode) {
    return getCitiesForCountry(countryCode).filter(city => 
      city.toLowerCase().includes(searchLower)
    );
  }
  
  // Search all countries
  const results: string[] = [];
  Object.values(citiesByCountry).forEach(cities => {
    cities.forEach(city => {
      if (city.toLowerCase().includes(searchLower) && !results.includes(city)) {
        results.push(city);
      }
    });
  });
  return results.slice(0, 20);
};
